import { isAutoRentalTile, TAutoRentalTile } from '@/utility/mapAutoSearchResultToTile';
import { isCampgroundTile, ISearchResultTile } from '@/utility/mapSearchResultToTile';

export const computeCustomListingTitle = (listingTile: ISearchResultTile | TAutoRentalTile) => {
  if (!isAutoRentalTile(listingTile) && (isCampgroundTile(listingTile) || listingTile.isStay)) {
    return undefined;
  }

  // Use Year Make Model format
  return listingTile.details?.year && listingTile.details?.make && listingTile.details?.model
    ? `${listingTile.details.year} ${listingTile.details.make} ${listingTile.details.model}`
    : undefined;
};
